import styled from 'styled-components';
import { Provider } from 'react-redux';
import { store } from 'store';
import { ToastrManagerComponent } from 'components/common/toaster/toastr-manager-component';
import { Modal } from 'components/common/modal';
import { muiTheme } from 'constants/mui-theme';
import JoinManger from 'components/join/components/join';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { TranslationProvider } from 'contexts/translation-context';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import 'assets/stylesheets/preapp.scss';
import 'assets/stylesheets/global-styles.scss';
import { useEffect } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { CAPTCHA_URL } from 'constants/urls';
import GlobalStyle from './global-styles';

const stripePromise = loadStripe(CONFIG.STRIPE_API_KEY);

const SiteWrapper = styled.div``;

export const App = () => {
  useEffect(() => {
    if (CONFIG.__ENV === 'production') {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.id = 'hs-script-loader';
      s.async = true;
      s.defer = true;
      s.src = '//js.hs-scripts.com/464503.js';
      const x = document.getElementsByTagName('script')[0];
      x?.parentNode?.insertBefore(s, x);
    }
  }, []);

  return (
    <SiteWrapper>
      <GlobalStyle />
      <Provider store={store}>
        <Elements stripe={stripePromise}>
          <TranslationProvider>
            <MuiThemeProvider theme={muiTheme}>
              <Modal className="modal-class" />
              <ToastrManagerComponent />
              <GoogleReCaptchaProvider reCaptchaKey={CAPTCHA_URL}>
                <JoinManger />
              </GoogleReCaptchaProvider>
            </MuiThemeProvider>
          </TranslationProvider>
        </Elements>
      </Provider>
    </SiteWrapper>
  );
};

export default App;
